export enum Breakpoint {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export enum Template {
  SMALL = 'small',
  MEDIUM = 'medium',
  MEDIUM_SPOTLIGHT = 'medium-spotlight',
  LARGE = 'large',
  LARGE_SPOTLIGHT = 'large-spotlight',
}

export type SectionDef = [Template, number];
export type Breakpoints = {
  [value in Breakpoint]?: {
    columns: number;
    sections: SectionDef[];
  };
}

export interface Layout {
  id: string;
  label: string;
  breakpoints: Breakpoints;
}
